import { useEffect, useReducer, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import Header from "../../components/header";
import { friendspage } from "../../functions/reducers";
import {
  getFriendsPageInfos,
  searchFriends,
  getFavorites,
  getFriendsBirthdays,
  getFollowers,
  getFollowing,
  getFriendSuggestions,
  getBlockedUsers,
} from "../../functions/user";
import Card from "./Card";
import "./style.css";

export default function Friends() {
  const { user } = useSelector((state) => ({ ...state }));
  const { type } = useParams();
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [favorites, setFavorites] = useState([]);
  const [birthdays, setBirthdays] = useState([]);
  const [followers, setFollowers] = useState([]);
  const [following, setFollowing] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [blockedUsers, setBlockedUsers] = useState([]);

  const [{ data }, dispatch] = useReducer(friendspage, {
    loading: false,
    data: {},
    error: "",
  });

  useEffect(() => {
    getData();
    loadFavorites();
    loadBirthdays();
    loadFollowers();
    loadFollowing();
    loadSuggestions();
    loadBlockedUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getData = async () => {
    dispatch({ type: "FRIENDS_REQUEST" });
    const data = await getFriendsPageInfos(user.token);
    if (data.status === "ok") {
      dispatch({ type: "FRIENDS_SUCCESS", payload: data.data });
    } else {
      dispatch({ type: "FRIENDS_ERROR", payload: data.data });
    }
  };

  const loadFavorites = async () => {
    const res = await getFavorites(user.token);
    if (res.status === "ok") {
      setFavorites(res.data);
    }
  };

  const loadBirthdays = async () => {
    const res = await getFriendsBirthdays(user.token);
    if (res.status === "ok") {
      setBirthdays(res.data);
    }
  };

  const loadFollowers = async () => {
    const res = await getFollowers(user.token);
    if (res.status === "ok") {
      setFollowers(res.data);
    }
  };

  const loadFollowing = async () => {
    const res = await getFollowing(user.token);
    if (res.status === "ok") {
      setFollowing(res.data);
    }
  };

  const loadSuggestions = async () => {
    const res = await getFriendSuggestions(user.token);
    if (res.status === "ok") {
      setSuggestions(res.data);
    }
  };

  const loadBlockedUsers = async () => {
    const res = await getBlockedUsers(user.token);
    if (res.status === "ok") {
      setBlockedUsers(res.data);
    }
  };

  const handleSearch = async (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (value.trim() === "") {
      setSearchResults([]);
      setIsSearching(false);
      return;
    }

    setIsSearching(true);
    const res = await searchFriends(value, user.token);
    if (res.status === "ok") {
      setSearchResults(res.data);
    }
  };

  const clearSearch = () => {
    setSearchTerm("");
    setSearchResults([]);
    setIsSearching(false);
  };

  const getMonthName = (month) => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return months[month - 1];
  };

  const todayBirthdays = birthdays.filter(b => b.isToday);
  const upcomingBirthdays = birthdays.filter(b => !b.isToday && b.daysUntilBirthday <= 30);

  return (
    <>
      <Header page="friends" />
      <div className="friends">
        <div className="friends_left">
          <div className="friends_left_header">
            <h3>Friends</h3>
            <div className="small_circle">
              <i className="settings_filled_icon"></i>
            </div>
          </div>
          <div className="friends_left_wrap">
            <Link
              to="/friends"
              className={`mmenu_item hover3 ${
                type === undefined && "active_friends"
              }`}
            >
              <div className="small_circle">
                <i className="friends_home_icon "></i>
              </div>
              <span>Home</span>
              <div className="rArrow">
                <i className="right_icon"></i>
              </div>
            </Link>
            <Link
              to="/friends/requests"
              className={`mmenu_item hover3 ${
                type === "requests" && "active_friends"
              }`}
            >
              <div className="small_circle">
                <i className="friends_requests_icon"></i>
              </div>
              <span>Friend Requests</span>
              {data.requests && data.requests.length > 0 && (
                <span className="friends_count">{data.requests.length}</span>
              )}
              <div className="rArrow">
                <i className="right_icon"></i>
              </div>
            </Link>
            <Link
              to="/friends/sent"
              className={`mmenu_item hover3 ${
                type === "sent" && "active_friends"
              }`}
            >
              <div className="small_circle">
                <i className="friends_requests_icon"></i>
              </div>
              <span>Sent Requests</span>
              <div className="rArrow">
                <i className="right_icon"></i>
              </div>
            </Link>
            <Link
              to="/friends/suggestions"
              className={`mmenu_item hover3 ${
                type === "suggestions" && "active_friends"
              }`}
            >
              <div className="small_circle">
                <i className="friends_suggestions_icon"></i>
              </div>
              <span>Suggestions</span>
              <div className="rArrow">
                <i className="right_icon"></i>
              </div>
            </Link>
            <Link
              to="/friends/all"
              className={`mmenu_item hover3 ${
                type === "all" && "active_friends"
              }`}
            >
              <div className="small_circle">
                <i className="all_friends_icon"></i>
              </div>
              <span>All Friends</span>
              {data.friends && data.friends.length > 0 && (
                <span className="friends_count">{data.friends.length}</span>
              )}
              <div className="rArrow">
                <i className="right_icon"></i>
              </div>
            </Link>
            <Link
              to="/friends/favorites"
              className={`mmenu_item hover3 ${
                type === "favorites" && "active_friends"
              }`}
            >
              <div className="small_circle">
                <i className="favorites_icon"></i>
              </div>
              <span>Favorites</span>
              {favorites.length > 0 && (
                <span className="friends_count">{favorites.length}</span>
              )}
              <div className="rArrow">
                <i className="right_icon"></i>
              </div>
            </Link>
            <Link
              to="/friends/birthdays"
              className={`mmenu_item hover3 ${
                type === "birthdays" && "active_friends"
              }`}
            >
              <div className="small_circle">
                <i className="birthdays_icon"></i>
              </div>
              <span>Birthdays</span>
              {todayBirthdays.length > 0 && (
                <span className="friends_count">{todayBirthdays.length}</span>
              )}
              <div className="rArrow">
                <i className="right_icon"></i>
              </div>
            </Link>
            <Link
              to="/friends/followers"
              className={`mmenu_item hover3 ${
                type === "followers" && "active_friends"
              }`}
            >
              <div className="small_circle">
                <i className="friends_home_icon"></i>
              </div>
              <span>Followers</span>
              {followers.length > 0 && (
                <span className="friends_count">{followers.length}</span>
              )}
              <div className="rArrow">
                <i className="right_icon"></i>
              </div>
            </Link>
            <Link
              to="/friends/following"
              className={`mmenu_item hover3 ${
                type === "following" && "active_friends"
              }`}
            >
              <div className="small_circle">
                <i className="friends_home_icon"></i>
              </div>
              <span>Following</span>
              {following.length > 0 && (
                <span className="friends_count">{following.length}</span>
              )}
              <div className="rArrow">
                <i className="right_icon"></i>
              </div>
            </Link>
            <Link
              to="/friends/blocked"
              className={`mmenu_item hover3 ${
                type === "blocked" && "active_friends"
              }`}
            >
              <div className="small_circle">
                <i className="settings_filled_icon"></i>
              </div>
              <span>Blocked</span>
              {blockedUsers.length > 0 && (
                <span className="friends_count">{blockedUsers.length}</span>
              )}
              <div className="rArrow">
                <i className="right_icon"></i>
              </div>
            </Link>
          </div>
        </div>
        <div className="friends_right">
          {/* Search Bar */}
          {(type === "all" || type === "favorites") && (
            <div className="friends_search_wrap">
              <div className="friends_search">
                <i className="search_icon"></i>
                <input
                  type="text"
                  placeholder="Search friends..."
                  value={searchTerm}
                  onChange={handleSearch}
                />
                {searchTerm && (
                  <div className="friends_search_clear" onClick={clearSearch}>
                    ✕
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Search Results */}
          {isSearching && (
            <div className="friends_right_wrap">
              <div className="friends_left_header">
                <h3>Search Results</h3>
              </div>
              <div className="flex_wrap">
                {searchResults.length > 0 ? (
                  searchResults.map((userr) => (
                    <Card
                      userr={userr}
                      key={userr._id}
                      type="friends"
                      getData={getData}
                    />
                  ))
                ) : (
                  <div className="no_results">No friends found</div>
                )}
              </div>
            </div>
          )}

          {!isSearching && (
            <>
              {(type === undefined || type === "requests") && (
                <div className="friends_right_wrap">
                  <div className="friends_left_header">
                    <h3>Friend Requests</h3>
                    {type === undefined && (
                      <Link to="/friends/requests" className="see_link hover3">
                        See all
                      </Link>
                    )}
                  </div>
                  <div className="flex_wrap">
                    {data.requests && data.requests.length > 0 ? (
                      data.requests.map((userr) => (
                        <Card
                          userr={userr}
                          key={userr._id}
                          type="request"
                          getData={getData}
                        />
                      ))
                    ) : (
                      <div className="no_results">No friend requests</div>
                    )}
                  </div>
                </div>
              )}
              {(type === undefined || type === "sent") && (
                <div className="friends_right_wrap">
                  <div className="friends_left_header">
                    <h3>Sent Requests</h3>
                    {type === undefined && (
                      <Link to="/friends/sent" className="see_link hover3">
                        See all
                      </Link>
                    )}
                  </div>
                  <div className="flex_wrap">
                    {data.sentRequests && data.sentRequests.length > 0 ? (
                      data.sentRequests.map((userr) => (
                        <Card
                          userr={userr}
                          key={userr._id}
                          type="sent"
                          getData={getData}
                        />
                      ))
                    ) : (
                      <div className="no_results">No sent requests</div>
                    )}
                  </div>
                </div>
              )}
              {(type === undefined || type === "all") && (
                <div className="friends_right_wrap">
                  <div className="friends_left_header">
                    <h3>Friends</h3>
                    {type === undefined && (
                      <Link to="/friends/all" className="see_link hover3">
                        See all
                      </Link>
                    )}
                  </div>
                  <div className="flex_wrap">
                    {data.friends && data.friends.length > 0 ? (
                      data.friends.map((userr) => (
                        <Card
                          userr={userr}
                          key={userr._id}
                          type="friends"
                          getData={getData}
                        />
                      ))
                    ) : (
                      <div className="no_results">No friends yet</div>
                    )}
                  </div>
                </div>
              )}
              {type === "favorites" && (
                <div className="friends_right_wrap">
                  <div className="friends_left_header">
                    <h3>Favorites ⭐</h3>
                  </div>
                  <div className="flex_wrap">
                    {favorites.length > 0 ? (
                      favorites.map((userr) => (
                        <Card
                          userr={userr}
                          key={userr._id}
                          type="friends"
                          getData={() => {
                            getData();
                            loadFavorites();
                          }}
                        />
                      ))
                    ) : (
                      <div className="no_results">No favorites yet. Add friends to favorites from their profile!</div>
                    )}
                  </div>
                </div>
              )}
              {type === "birthdays" && (
                <div className="friends_right_wrap">
                  {todayBirthdays.length > 0 && (
                    <>
                      <div className="friends_left_header">
                        <h3>🎂 Today's Birthdays</h3>
                      </div>
                      <div className="birthdays_list">
                        {todayBirthdays.map((friend) => (
                          <Link to={`/profile/${friend.username}`} key={friend._id} className="birthday_card">
                            <img src={friend.picture} alt="" />
                            <div className="birthday_info">
                              <div className="birthday_name">
                                {friend.first_name} {friend.last_name}
                              </div>
                              <div className="birthday_date">
                                🎉 Birthday is today! Wish them a happy birthday!
                              </div>
                            </div>
                          </Link>
                        ))}
                      </div>
                    </>
                  )}
                  <div className="friends_left_header" style={{ marginTop: todayBirthdays.length > 0 ? "20px" : "0" }}>
                    <h3>📅 Upcoming Birthdays</h3>
                  </div>
                  <div className="birthdays_list">
                    {upcomingBirthdays.length > 0 ? (
                      upcomingBirthdays.map((friend) => (
                        <Link to={`/profile/${friend.username}`} key={friend._id} className="birthday_card">
                          <img src={friend.picture} alt="" />
                          <div className="birthday_info">
                            <div className="birthday_name">
                              {friend.first_name} {friend.last_name}
                            </div>
                            <div className="birthday_date">
                              {getMonthName(friend.bMonth)} {friend.bDay} • In {friend.daysUntilBirthday} day{friend.daysUntilBirthday > 1 ? "s" : ""}
                            </div>
                          </div>
                        </Link>
                      ))
                    ) : (
                      <div className="no_results">No upcoming birthdays in the next 30 days</div>
                    )}
                  </div>
                  {birthdays.length > upcomingBirthdays.length + todayBirthdays.length && (
                    <>
                      <div className="friends_left_header" style={{ marginTop: "20px" }}>
                        <h3>🗓️ All Birthdays</h3>
                      </div>
                      <div className="birthdays_list">
                        {birthdays.filter(b => !b.isToday && b.daysUntilBirthday > 30).map((friend) => (
                          <Link to={`/profile/${friend.username}`} key={friend._id} className="birthday_card">
                            <img src={friend.picture} alt="" />
                            <div className="birthday_info">
                              <div className="birthday_name">
                                {friend.first_name} {friend.last_name}
                              </div>
                              <div className="birthday_date">
                                {getMonthName(friend.bMonth)} {friend.bDay}
                              </div>
                            </div>
                          </Link>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              )}
              {type === "followers" && (
                <div className="friends_right_wrap">
                  <div className="friends_left_header">
                    <h3>Followers ({followers.length})</h3>
                  </div>
                  <div className="flex_wrap">
                    {followers.length > 0 ? (
                      followers.map((userr) => (
                        <Card
                          userr={userr}
                          key={userr._id}
                          type="follower"
                          getData={() => {
                            getData();
                            loadFollowers();
                          }}
                        />
                      ))
                    ) : (
                      <div className="no_results">No followers yet</div>
                    )}
                  </div>
                </div>
              )}
              {type === "following" && (
                <div className="friends_right_wrap">
                  <div className="friends_left_header">
                    <h3>Following ({following.length})</h3>
                  </div>
                  <div className="flex_wrap">
                    {following.length > 0 ? (
                      following.map((userr) => (
                        <Card
                          userr={userr}
                          key={userr._id}
                          type="following"
                          getData={() => {
                            getData();
                            loadFollowing();
                          }}
                        />
                      ))
                    ) : (
                      <div className="no_results">Not following anyone yet</div>
                    )}
                  </div>
                </div>
              )}
              {(type === undefined || type === "suggestions") && (
                <div className="friends_right_wrap">
                  <div className="friends_left_header">
                    <h3>People You May Know</h3>
                    {type === undefined && (
                      <Link to="/friends/suggestions" className="see_link hover3">
                        See all
                      </Link>
                    )}
                  </div>
                  <div className="flex_wrap">
                    {suggestions.length > 0 ? (
                      suggestions.map((userr) => (
                        <Card
                          userr={userr}
                          key={userr._id}
                          type="suggestion"
                          getData={() => {
                            getData();
                            loadSuggestions();
                          }}
                        />
                      ))
                    ) : (
                      <div className="no_results">No suggestions available</div>
                    )}
                  </div>
                </div>
              )}
              {type === "blocked" && (
                <div className="friends_right_wrap">
                  <div className="friends_left_header">
                    <h3>Blocked Users</h3>
                  </div>
                  <div className="flex_wrap">
                    {blockedUsers.length > 0 ? (
                      blockedUsers.map((userr) => (
                        <Card
                          userr={userr}
                          key={userr._id}
                          type="blocked"
                          getData={() => {
                            getData();
                            loadBlockedUsers();
                          }}
                        />
                      ))
                    ) : (
                      <div className="no_results">No blocked users</div>
                    )}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}
